<template>
	<div class="modal-wrapper modal-pause-subscription-wrapper">
		<div class="pause-subscription-container bg-white">
			<div class="modal-text">
				<div class="pause-subscription-modal-title">
					{{ $tc('modals.pauseSubscription.title') }}
				</div>
				<div class="pause-subscription-modal-text">
					<p v-html="$tc('modals.pauseSubscription.text[0]')" />
					<p v-html="$tc('modals.pauseSubscription.text[1]')" />
					<p v-html="$tc('modals.pauseSubscription.text[2]')" />
				</div>
			</div>
			<div class="modal-actions-wrap">
				<OptionsSelect
					v-model="period"
					:options="pausePeriodOptions"
					:is-hidden-label="true"
				/>
				<button class="modal-btn button-pink" @click="continueHandler">
					{{ $tc('modals.pauseSubscription.continueText') }}
				</button>
				<button class="modal-btn button-default" @click="onClose">
					{{ $tc('modals.pauseSubscription.cancelText') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import { OptionsSelect } from '~/components/interface'

export default {
	name: 'ModalPauseSubscription',
	components: {
		OptionsSelect
	},
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			period: 1
		}
	},
	computed: {
		pausePeriodOptions () {
			return [1, 2, 3, 4, 5, 6].map((value) => {
				return {
					title: `${value} ${value === 1 ? this.$tc('modals.pauseSubscription.monthText') : this.$tc('modals.pauseSubscription.monthsText')}`,
					id: value
				}
			})
		}
	},
	methods: {
		continueHandler () {
			this.onConfirm(+this.period)
		}
	}
}
</script>

<style lang="scss">
.modal-pause-subscription-wrapper {
	margin: auto;
	.pause-subscription {
		&-container {
			width: 420px;
			padding: 32px;
			min-height: 250px;
			border-radius: 8px;
			box-shadow: 0px 4px 21px rgba(0, 0, 0, 0.19);
			.modal-row {
				@include respond-below(phone) {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
				}
			}
		}
		&-modal-title {
			font-weight: 500;
			font-size: 32px;
			line-height: 38px;
			margin-bottom: 13px;
			text-align: center;
			@include respond-below(phone) {
				font-size: 26px;
				line-height: 32px;
			}
		}
		&-modal-text {
			p {
				font-size: 16px;
				line-height: 21px;
				margin-bottom: 15px;
			}
		}
	}
	.modal-actions-wrap {
		padding-top: 20px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: center;
		@include respond-below(phone) {
			padding-top: 20px;
		}
		.text-input-wrap {
			width: 80%;
			select.text-input {
				border-radius: 4px;
				border-color: #2b2b2b;
			}
		}
	}
}
</style>
